import { render, staticRenderFns } from "./BusinessDistrict.vue?vue&type=template&id=0f40074e&scoped=true"
import script from "./BusinessDistrict.vue?vue&type=script&lang=js"
export * from "./BusinessDistrict.vue?vue&type=script&lang=js"
import style0 from "./BusinessDistrict.vue?vue&type=style&index=0&id=0f40074e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40074e",
  null
  
)

export default component.exports